import React, { useEffect, useState } from 'react'
import HeaderTwo from './HeaderTwo'
import FooterTwo from './FooterTwo'
import { Styles } from "./styles/serviceBox.js";
import AboutUsTwo from './AboutUsTwo'

import State from './States'
import { GetApi, PostApi } from '../services/CommonService2.js';
import LoginModal from './LoginModal.js';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min.js';

function CollegeScholars() {
    const [constituencySlider, setConstituencySlider] = useState("");
    const [modalUp, setModalUp] = useState(false)

    const history = useHistory()


    useEffect(() => {
        getHomeBanners()
    }, [])

    const getHomeBanners = async () => {
        const reqparam = {
            pageno: '-1',
            query: { status: 'Active' }
        }

        const intoContentData = await GetApi(reqparam, "INTRO");
        setConstituencySlider(intoContentData.data)
    }
    const partnerPage = async () => {
        var tntId = JSON.parse(localStorage.getItem('tID'))

        const userdata = JSON.parse(localStorage.getItem(`userdata${tntId}`))
        if (userdata == null) {
            setModalUp(true)
            toast.info('login to check course details', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        else {
            history.push('/partner-onboard')
        }

    }

    const openModal = () => {
        setModalUp(false)
    }

    const logIn = () => {

    }
    return (
        <Styles>
            <div>
                <HeaderTwo />

                {constituencySlider.length != 0 && <div id="carouselExampleIndicators" class="carousel slide " data-bs-ride="carousel" onClick={partnerPage}>
                    <div class="carousel-inner mt-2" style={{ cursor: "pointer" }}>
                        {constituencySlider?.map((ele, ind) => {
                            if (ind == 0) {
                                return (
                                    <div className={ind == 0 ? "carousel-item active " : "carousel-item"} >
                                        <img src={ele.webicon} className="d-block" alt="..." />
                                    </div>
                                )
                            }

                        })}

                    </div>
                </div>
                }

                <AboutUsTwo />

                {/* <State/> */}

                <FooterTwo />

            </div>

            {modalUp && <LoginModal onClose={openModal} login={logIn}></LoginModal>}
        </Styles>
    )
}

export default CollegeScholars